import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ handleEnrollClick }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    if (!isHomePage) {
      window.location.href = '/' + sectionId;
      return;
    }
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav>
      <div className="nav-container">
        <div className="nav-left">
          <Link to="/" className="logo">TECH WALA</Link>
          <div className="nav-links">
            <a href="#home" onClick={(e) => scrollToSection(e, '#home')}>Home</a>
            <a href="#courses" onClick={(e) => scrollToSection(e, '#courses')}>Courses</a>
            <a href="#instructors" onClick={(e) => scrollToSection(e, '#instructors')}>Instructors</a>
            <a href="#projects" onClick={(e) => scrollToSection(e, '#projects')}>Projects</a>
            <div className="nav-dropdown">
              <span className="nav-dropdown-trigger">Free Tools</span>
              <div className="dropdown-menu">
                <Link to="/tools/image-to-video" className="dropdown-item">
                  🎬 Image to Animation Video
                </Link>
                <Link to="/tools/qr-generator" className="dropdown-item">
                  📱 QR Code Generator
                </Link>
                <Link to="/tools/color-picker" className="dropdown-item">
                  🎨 Color Picker & Converter
                </Link>
                <Link to="/tools/password-generator" className="dropdown-item">
                  🔐 Password Generator
                </Link>
                <Link to="/tools/image-compressor" className="dropdown-item">
                  🗜️ Image Compressor
                </Link>
                <Link to="/tools/text-to-speech" className="dropdown-item">
                  🔊 Text to Speech
                </Link>
                <Link to="/tools/image-to-pdf" className="dropdown-item">
                  📄 Image to PDF
                </Link>
                <Link to="/tools/pdf-to-images" className="dropdown-item">
                  🖼️ PDF to Images
                </Link>
                <Link to="/tools/video-trimmer" className="dropdown-item">
                  ✂️ Video Trimmer
                </Link>
                <Link to="/tools/background-remover" className="dropdown-item">
                  🎭 Background Remover
                </Link>
                <Link to="/tools/audio-visualizer" className="dropdown-item">
                  🎵 Audio Visualizer
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="nav-right">
          <button className="login" onClick={handleEnrollClick}>Login</button>
          <button className="signup" onClick={handleEnrollClick}>Sign Up</button>
          <button className="signup" onClick={handleEnrollClick}>Contact Us</button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
